import { produceCallback } from '../produce-callback';
import { modifyExistingQueryData } from '../query';
import { getTimesheetFromTimesheetsQueryData, updateTimesheetInTimesheetsQueryData, } from '../timesheets/query';
export function getTimesheetQueryKey(id) {
    return ['timesheets', id];
}
export function invalidateTimesheetQuery(queryClient, id) {
    return queryClient.invalidateQueries({ queryKey: getTimesheetQueryKey(id) });
}
export function getTimesheetQueryData(queryClient, id) {
    const tsQd = queryClient.getQueryData(getTimesheetQueryKey(id));
    return tsQd ? tsQd : getTimesheetFromTimesheetsQueryData(queryClient, id);
}
export const setTimesheetQueryData = (queryClient, id, updater) => {
    modifyExistingQueryData(queryClient, getTimesheetQueryKey(id), produceCallback(updater));
    updateTimesheetInTimesheetsQueryData(queryClient, id, 
    // @ts-expect-error -- this is close enough
    produceCallback(updater));
};
//# sourceMappingURL=query.js.map